import axios from 'axios';
import login from "../../src/views/login";
let configUrl = "";

const Const = {
    NET: {
        APP_VER: '1.0.1_20261008_01',
        GET_CONFIG_OVER: false,
        // END_POINT: 'http://api.skf.rebuildsoft.com/admin/1',
        END_POINT: getUrl(),
        BASE_URL: 'http://10.0.0.192:8087',
        // END_POINT: 'http://10.0.0.192:8088/admin/1',
        // END_POINT: 'http://10.0.0.239:8087/admin/1',
        // END_POINT: 'http://192.168.43.3:8089/admin/1',

        END_EMAIL_POINT: initEndEmailPoint(),
        // END_EMAIL_POINT: 'http://api.skf.rebuildsoft.com/client/1',
        // END_EMAIL_POINT: 'http://10.0.0.117:8087/client/1',
        VERSION: 1,
        CLIENT: 1,

        FILE_URL_PREFIX: 'https://rebuild-test.oss-cn-hangzhou.aliyuncs.com/file/',
        IMG_URL_PREFIX: "https://rebuild-test.oss-cn-hangzhou.aliyuncs.com/img/",


        FILE_UPLOAD_END_POINT: "https://api.notary.rebuildsoft.com/file/file-upload",
        DOWNLOAD_ZIP: "https://api.notary.rebuildsoft.com/file/file-zip-upload",

        DOWNLOAD_EXCEL: 'http://api.tracker.rebuildsoft.com/download/excel-template',

        IMPORT_FILE: initImportFile(),
        // IMPORT_FILE: 'http://api.skf.rebuildsoft.com/file/',
        // IMPORT_FILE: 'http://10.0.0.117:8087/file/',


    },
    //  邮箱验证正则
    EMAIL_REG: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
    DATA: {
        KEY_PREFIX: 'skf.data.',
        KEY_TOKEN: 'token',
        KEY_USER: 'user',
        KEY_RECENT_ACCOUNT_LIST: 'recent-account-list',
        KEY_USER_TYPE: 'user-type',
        KEY_PROJECT: 'project',
        KEY_LANG: 'lang'
    },
    ERROR: {
        ERROR_NETWORK: -10000,
        ERROR_INVALID: -1,
        // ERROR_PARAM_NOT_SET: 1,
        ERROR_INVALID_TOKEN: 4004,
        ERROR_LOGIN_FAIL: 3,
        ERROR_WRONG_PARAM: 4,
        ERROR_NOT_EXIST: 5,
        ERROR_EXIST: 6,
        ERROR_ORG_NOT_EXIST: 7,
        ERROR_ORG_MEMBER_NOT_EXISTS: 8,
        ERROR_REGISTER: 9,
        ERROR_USER_NOT_EXISTS: 10,
        ERROR_PHONE_HAS_BEEN_TAKEN: 11,
        ERROR_BIND_USER_BIND_EXISTS: 12,
        ERROR_WRONG_TYPE: 13,
        ERROR_SAVE_ERROR: 14,
        ERROR_ACTION_NOT_ALLOWED: 15,
        ERROR_WRONG_VERIFICATION_CODE: 16,
        ERROR_SEND_PHONE_VCODE_TOO_OFTEN: 17
    },
    IMAGE_TYPE: [
        'png',
        'jpg',
        'jpeg',
        'gif',
        'bmp',
        'pdf'
    ],

    OFFICE_TYPE: [
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx'
    ],
    deviceStatusList: [
        {
            value: '0',
            label: '正常'
        },
        {
            value: '1',
            label: '告警'
        },
        {
            value: '2',
            label: '异常'
        },
        {
            value: '3',
            label: '离线'
        },
        {
            value: '4',
            label: '关闭'
        },
    ],
    // 仓库状态
    storageStatus: [
        {
            value: '0'
        },
        {
            value: '1'
        },
        {
            value: '',
        }
    ],
    // 仓库状态
    storageTypeList: [
        {
            value: '',
            label: '全部'
        },
        {
            value: '0',
            label: 'NB'
        },
        {
            value: '1',
            label: 'Lora'
        }
    ],
    emailRateList: [
        {
            value: 0
        }, {
            value: 1
        }, {
            value: 2
        }, {
            value: 3
        }, {
            value: 4
        }
    ],
    slip_tubes: [
        {
            value: '125',
            label: '125'
        },{
            value: '250',
            label: '250'
        }
    ],
    temperatures: [
        {
            value: '47-63°C',
            label: '47-63°C'
        },
        {
            value: '63-78°C',
            label: '63-78°C'
        },
        {
            value: '78-93°C',
            label: '78-93°C'
        },
        {
            value: '93-107°C',
            label: '93-107°C'
        },
    ],
    loads: [
        {
            value: '低载荷',
            label: '低载荷'
        }, {
            value: '一般载荷',
            label: '一般载荷'
        }, {
            value: '高载荷',
            label: '高载荷'
        }, {
            value: '极高载荷',
            label: '极高载荷'
        },
    ],
    deviceType: [
        {
            value: 0,
            label: 'NB'
        }, {
            value: 1,
            label: 'Lora'
        }
    ],
    DEVICE_TYPE:{
        NB: 0,
        LORA: 1
    },
    FLAG_APP_YES : 1,
    FLAG_APP_NO : 2,
    APP_SAVE : 'save',
    APP_UPDATE : 'update',
    APP_CANCEL : 'cancel',
    oldMonth : num(0,13),
    // hours : num(1,24,true),
    month : getNum(0, 24, undefined, true),
    hours : getNum(1, 13, true, false),
    ROLE_AGENT: {
        OEM: 11,    // OEM客户
        AFM: 100    // AFM管理员
    },
    MAP: {
        icon_adr: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAAAXNSR0IArs4c6QAAAvNJREFUOBF9VF9IU2EU/843J8pk4B+SAgUrI5KeknGXrrAIdC1CivIleykDyUCIFHqQ9KmXSCqol8Leih6UTTEUBtvwXiEfJg2KGgoGUeRC2RKnu6dz7vrGTaYXPr7D7/c7v/t955x7hdjjCS8tlfHaQyJgJxmKGicEYh+CaKe91uIBfgCKaQHwJODTFuw5BYMwYkk6pj8GAb0CxVeyfisQPuUN8ChhVwg7TPszl0/rbwPYZs4yQESYjBnvaL8IEh42VLofNDU1Ze1vSiQSpUu/14fQxAEAmDjfql2mHS3NZETvD0bmcCqmX7UnFYtDEaOLtZzDPLyPx11b65kVCmcCPm/BIGgYjSKLnVIimiVy/IKmfVGGoaj+Rgg853S76mR2baMDUVQ6SsSAEgRjhh+y5iKAGKDbDXLMmOJZyznb6Y12SaCHhMkOr3dZCYSJz6kL0w1V7v28OGZM8azlHMI8EsCsJrefipydn6+m49U50DHGheTFMWN5Lq/kHBRYIwXIZervQWVw1uNJUT1WTch1KMwEk44Pq3kuj9IJDhD2na6AcR6Yyej8Eaa4NbTuUXQzGNXjvAi+wZhq20zsQz3x9WSyKKnnNGF8hVxv3lsImraX1OAzNDRzvDhmTPGbuHWNZiZTW+YMWYNEbxmh4I6r3Hmorbn5lxIW28OJREU6tZYk/XjAd/IWd0FUlDtHydFM/9kaKZZkx9Kp9bs0f27plJbWMuC3UjuG6Co9UxG9xZ5gj6cixjFAHBQSHvk17RtzlgEH/lbtKR1LNwHH+JiM2Z8wfWzEvaYqJ2VtzbDiCgZUYVNK53Uq2L5Mau2VEqg9EzNGiTtO1e/2NzZuKrxgwIC/pTlJQ9NNoks074XRpn9ED9WIP/Pbu/4PlCPvocjcMA3DfXBIP03FBpq5WUp+ETjl7bPrOLbauBOkt8lQTJ8g/DQl5ki1UNHqbW/79xOx6/+7giK4HqVuVxclf6T4cyVUdRZLVvpddz4JraKnVEl/AaacSPZvTsS6AAAAAElFTkSuQmCC",
        icon_per: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAqdJREFUOBGtlE9oE1EQxmc2MZEgpj3U2uqlSkWIqEgOiU0CAVPa2oqnevDgVRChSKAWeuhBkEKRqngSBI+K4iFt+keh0GzYHILiIRdrEYRapUIpBpI0zY4zu8naLun24sJm3pv5ft97eW/fA/jPDzr5ERHOZ/NnCPUTokNS1vp6gl8Qkfbjmhp+yOXaK1V9jAiGmezYDTOwjgivvYeUh1dCoV+7a9JW7ImUqt0sb9MqG10HxMeArouHfZ4WeaUtOamJRrR2fs8MZzPaPRZPEdCk63jbxEB3d8UOSD+9suKt/dyYQMBRNkhejYYfNXSWYTqb663pNMerMzIYCz9tCJzizLJ2lxCmXQr2D/SEFkVr/OUlIndN158g0KtmZqmM9mIh+/mY3Vy0wggrHpZhUdWGeGanvei5b4fq/Vs1Kp1qVhNGWPGwDJHwGi92JhEJfm8GOeUMhlnDg4XmLiOd40TOCXSqCcsbGRCNaQjQBkAbTpBzjTb42zTW2FhIFm+Sgi1OUA30eGo5d1I0iguqvs72hXhXV1n6PLtWDpvSNgz5hK0i6Rck0ezhnczyqbkNqBtl0qFaWv8t6/2prj/P8au0za12wYyu47P3+bw/EQxu1UVWGIxejlkdW0OYcqmaUBS4IyVjDf3U+pYnXqyUqmM2/YFdk6Gir+XoG8swEjn7BwjH+XZJyok50KUuEK0wwsYDgaJlKI2hWPg579RLPn7vZlVtuM7sG9KqdkO0wgjbEFpnWRI8msIXxCRfEEm+8+bBpUx3+Y8sBQKBbakXCgXPt61iHGr6CGv7GJ7ii2GUteZusWaPoUDyzKm5yA7RAy7GeBQ2w3WzQh18ojw84LIbcbw/ElLN/L/fpoaN8qL6sXMHKlH+ZMwbG2HNDd5Mb+TSj4bGHv8CUxUQzD0FyyoAAAAASUVORK5CYII=",
        icon_ele: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYCAYAAACIhL/AAAAAAXNSR0IArs4c6QAAANFJREFUSA3tl7EKwjAQhu9KXdRdIuhUR1/BxbfwJRwdfLU+hbM6FRpwKrRLC/drt6RuBtoTkuly3HFf/rsEwo/CHiGSk7KVbdfcIyXKuL5wUtfDlJyIUbm+ke0DgItb0wOcz5AbY15uwJj2syiXgF9RfYvVA3ot9sWddmetXYisoBawbqUmKlv1LY6AoZMcFYwKhioQmq/2HSTmO4E6tYDZxux69eMtDp1B9Qp6M9h0fP78UZrQU/+aD8h+mOsBEskVMgyZdp8moFqYb9Ni/HH1N9x+NESrzV2jAAAAAElFTkSuQmCC",
    },
    AUTH_LIST_MAP: {
        UPDATE: { key: 'device.update', value: '编辑/控制设备' },
        SEE: { key: 'device.see', value: '查看设备' },
        ENABLE: { key: 'device.enable', value: '启用/禁用设备' },
    }
}
function getUrl() {
    if (configUrl) {
        return `${configUrl}/admin/1`
    }
	let host = window.location.hostname;
	let endpoint = 'https://lcpapi.skf.com.cn';
	// let endpoint = 'https://lcptapi.skf.com.cn';
	// let endpoint = 'http://api.skf.rebuildsoft.com';
	switch (host) {
		case 'lcp.skf.com.cn': {
			endpoint = 'https://lcpapi.skf.com.cn'
		} break;
        case 'localhost':{
            endpoint = 'http://10.0.0.192:8087'
        } break;
		case 'lcptest.skf.com.cn':
        case 'tatest.skf.com.cn':
		case 'aws-skf-lcp-test-website.s3-website.cn-north-1.amazonaws.com.cn': {
			endpoint = 'https://lcptapi.skf.com.cn'
		}
	}

	return `${endpoint}/admin/1`

    /**
     * http://lcp.skf.com.cn/#/login
     * lcp@skf.com / skfTLDDadminwinson2021
     * owen.tao@skf.com / 123456
     *
     * https://tatest.skf.com.cn/#/login
     * 客户：Kevin.wk.li@skf.com / kevin1494
     * 超管：admin@skf.com / 7
     * 工厂：lierda / 7
     * 服务商：winson.wen@skf.com / 7
     * 组员：zuyuan@skf.com / 7
     * 组员：ceshi2@163.com / 7
    */
}

function initEndEmailPoint() {
    if (configUrl) {
        return `${configUrl}/client/1`
    }
	let host = window.location.hostname;
    let origin = window.location.origin
	let endpoint = 'http://api.skf.rebuildsoft.com/client/1';
	switch (host) {
		case '127.0.0.1':
		case '10.0.0.192': {
			// endpoint = 'http://10.0.0.117:8087/client/1'
			// endpoint = 'http://api.skf.rebuildsoft.com/client/1';
            // endpoint = 'http://lcptapi.skf.com.cn/client/1';
			endpoint = 'http://10.0.0.192:8087/client/1'
        } break;
		case 'localhost': {
			// endpoint = 'http://127.0.0.1:8083/client/1'
			// endpoint = 'http://api.skf.rebuildsoft.com/client/1';
			// endpoint = 'https://lcpapi.skf.com.cn/client/1'
			endpoint = 'http://10.0.0.192:8087/client/1'
		} break;
		case 'lcp.skf.com.cn': {
			endpoint = 'https://lcpapi.skf.com.cn/client/1'
		} break;
		case 'lcptest.skf.com.cn': {
			endpoint = 'https://lcptapi.skf.com.cn/client/1'
		} break;
		case 'tatest.skf.com.cn': {
			endpoint = 'https://lcptapi.skf.com.cn/client/1'
		} break;
		case 'aws-skf-lcp-test-website.s3-website.cn-north-1.amazonaws.com.cn': {
            endpoint = 'http://10.0.0.213:8087/client/1'
		} break;
        default:
            endpoint = 'http://10.0.0.213:8087/client/1'
            break;
	}

	return `${endpoint}`
}
function initImportFile() {
	// IMPORT_FILE: 'http://api.skf.rebuildsoft.com/file/',
    if (configUrl) {
        return `${configUrl}/file/`
    }
	let host = window.location.hostname;
    let origin = window.location.origin
	let endpoint = 'http://api.skf.rebuildsoft.com/file/';
	switch (host) {
		case '127.0.0.1':
		case '10.0.0.231': {
			endpoint = 'http://10.0.0.231:8087/file/'
			// endpoint = 'http://api.skf.rebuildsoft.com/file';
		} break;
		case 'localhost': {
			// endpoint = 'http://127.0.0.1:8083/file'
            endpoint = 'http://10.0.0.231:8087/file/'
		} break;
		case 'lcp.skf.com.cn': {
			endpoint = 'https://lcpapi.skf.com.cn/file/'
		} break;
		case 'lcptest.skf.com.cn': {
			endpoint = 'https://lcptapi.skf.com.cn/file/'
		} break;
		case 'tatest.skf.com.cn': {
			endpoint = 'https://lcptapi.skf.com.cn/file/'
		} break;
		case 'aws-skf-lcp-test-website.s3-website.cn-north-1.amazonaws.com.cn': {
			endpoint = 'https://lcptapi.skf.com.cn/file/'
		} break;
        case 'admin.skf.rebuildsoft.com': {
            endpoint = 'http://api.skf.rebuildsoft.com/file/'
        } break;
        default:
            endpoint = `${origin}/file/`
            break;
	}
	return `${endpoint}`
}
function num(min,max,bool) {
    let arr = []
    for (let i = min ; i <= max ; i++){
        if (i < 13) {
	        arr.push({
		        value: i,
		        disabled: bool
	        })
        } else if (i === 13) {
            if (!bool) {
	            arr.push({
		            value: 255,
		            disabled: bool
	            })
            } else {
	            arr.push({
		            value: i,
		            disabled: bool
	            })

            }
        }
    }
    return arr
}
function getNum(min, max, bool, hasReset) {
    const arr = [];
    for(let i = min; i <= max; i++) {
        arr.push({
            value: i,
            disabled: bool
        }) 
    }
    if(hasReset) {
        arr.push({
            value: 255,
            disabled: bool
        })
    }
    return arr;
}

function setConfigUrl() {
    return new Promise(resolve => {
        axios.get('/config.json')
            .then(response => {
                let config = response.data;
                console.log('get config:', config);
                configUrl = config.endpoint     // http://api.blabla.com
                if (configUrl) {
                    Const.NET.BASE_URL = configUrl
                    Const.NET.END_POINT = `${configUrl}/admin/1`
                    Const.NET.END_EMAIL_POINT = `${configUrl}/client/1`
                    Const.NET.IMPORT_FILE = `${configUrl}/file/`
                }
                Const.NET.GET_CONFIG_OVER = true
            })
            .catch(e => {
                console.log('config error ', e);
            })
            .finally(_ => {
                resolve()
            })
    })
}
setConfigUrl()
export default Const;
